export default defineNuxtPlugin((nuxtApp) => {
  const fetchAPI = $fetch.create({
    baseURL: '',
    onRequest: ({ options }) => {
      const sentry = nuxtApp.$sentryClientSide;
      const activeSpan = sentry.getActiveSpan();
      const baggage = activeSpan
        ? sentry.spanToBaggageHeader(activeSpan)
        : null;
      if (baggage) {
        options.headers.set('Baggage', baggage);
      }
    },
    onResponseError: ({ response }) => {
      if (response.status === 401) {
        useOidcAuth().login();
      }
    },
  });

  return {
    provide: {
      fetchAPI,
    },
  };
});
